import React from 'react'
import { Box, Button, CircularProgress, Typography } from '@mui/material'
import { SystemUpdateAlt } from '@mui/icons-material'

export const SectionTitle: React.FC<{ children: React.ReactNode }> = ({
  children
}) => (
  <Typography
    variant='overline'
    sx={{
      display: 'block',
      fontWeight: 600,
      bgcolor: 'action.hover',
      px: 2,
      py: 1
    }}
  >
    {children}
  </Typography>
)

const asnStateChipStyles: Record<string, { color: string; bgcolor: string }> = {
  Pendiente: { color: '#FF9C28', bgcolor: '#FFF4E5' },
  Controlado: { color: '#199D03', bgcolor: '#E8F5E9' }
}

export const AsnStateChip: React.FC<{ value?: string }> = ({ value }) => {
  if (!value) return null

  const style = asnStateChipStyles[value] ?? { color: '#000000', bgcolor: 'transparent' }

  return (
    <Box
      component='span'
      sx={{
        display: 'inline-block',
        px: 1.5,
        py: 0.25,
        borderRadius: '12px',
        fontSize: '0.8125rem',
        fontWeight: 400,
        color: style.color,
        bgcolor: style.bgcolor,
        border: `1px solid ${style.color}`
      }}
    >
      {value}
    </Box>
  )
}

export const DownloadButton: React.FC<{
  label: string
  loading: boolean
  disabled: boolean
  onClick: () => void
}> = ({ label, loading, disabled, onClick }) => (
  <Button
    variant='outlined'
    disabled={disabled}
    onClick={onClick}
    startIcon={
      loading ? (
        <CircularProgress size='0.9rem' />
      ) : (
        <SystemUpdateAlt fontSize='small' />
      )
    }
  >
    {label}
  </Button>
)

export const AsnDetailFooterActions: React.FC<{
  processId: number | null
  downloadingAsn: boolean
  downloadingResult: boolean
  onDownloadAsn: () => void
  onDownloadResult: () => void
  onClose: () => void
}> = ({
  processId,
  downloadingAsn,
  downloadingResult,
  onDownloadAsn,
  onDownloadResult,
  onClose
}) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      px: 3,
      pb: 2,
      pt: 1
    }}
  >
    <Box sx={{ display: 'flex', gap: 2 }}>
      <DownloadButton
        label='Descargar ASN'
        loading={downloadingAsn}
        disabled={!processId || downloadingAsn}
        onClick={onDownloadAsn}
      />
      <DownloadButton
        label='Descargar resultado de carga'
        loading={downloadingResult}
        disabled={!processId || downloadingResult}
        onClick={onDownloadResult}
      />
    </Box>
    <Button variant='outlined' onClick={onClose}>
      Cerrar
    </Button>
  </Box>
)
